import { render, staticRenderFns } from "./TimelineMessageHeaderCard.vue?vue&type=template&id=0acc422a&scoped=true&"
import script from "./TimelineMessageHeaderCard.vue?vue&type=script&lang=js&"
export * from "./TimelineMessageHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./TimelineMessageHeaderCard.vue?vue&type=style&index=0&id=0acc422a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc422a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
